import React from 'react';
import ReactLoading from "react-loading";


export default function Loading() {
    return (
        <ReactLoading type={'bubbles'} color="#000"/>
    );
}